/**
 * 2026.1 — knowledge base ASSEMBLY.
 *
 * Wires the per-topic scaffolds (rates, thresholds, references) into a
 * single `AtoKnowledgeBase` object, validated at import-time by the Zod
 * schema. A parse failure here means the ruleset content drifted from
 * the shape declared in `../types.ts` — fail loud, not silent.
 *
 * ADDING A NEW VERSION (2026.2, 2026.3, ...):
 *  1. Copy `2026.1/` to `<newVersion>/`.
 *  2. Edit `rates.ts`, `thresholds.ts`, `references.ts` — keep `status:
 *     "scaffold"` until reviewed.
 *  3. Register the new module in `../registry.ts` (append a new
 *     ATO_RULESETS entry with the higher version + updated
 *     effectiveFrom / lastReviewed).
 *  4. Add a `case` in `../index.ts` `getKnowledge()`.
 *  5. When ready to go live, bump `current.ts` CURRENT_ATO_RULESET_VERSION.
 *     The previous version's file is FROZEN forever — never edit.
 */

import {
  AtoKnowledgeBaseSchema,
  type AtoKnowledgeBase,
} from "../types";
import { rates } from "./rates";
import { thresholds } from "./thresholds";
import { references } from "./references";

const raw: AtoKnowledgeBase = {
  version: "2026.1",
  rates,
  thresholds,
  references,
  effective: {
    financialYearStart: "2025-07-01",
    financialYearEnd: "2026-06-30",
    note: "FY26 scaffold. Populate rates/thresholds before flipping section status to 'confirmed'.",
  },
};

// Zod parse-at-import so mis-typed content trips the build/dev-server
// immediately rather than manifesting as an undefined field at runtime.
export const knowledge_2026_1: AtoKnowledgeBase =
  AtoKnowledgeBaseSchema.parse(raw);
